export default __webpack_public_path__ + "static/media/logo_sgi_intec.8e1082e8.png";